import { WifiOff } from 'lucide-react';

export default function OfflineBanner() {
  return (
    <div className="sticky top-0 z-50 flex items-center gap-2 bg-amber-500 px-4 py-2 text-sm text-white">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>You're offline — changes may not save until your connection is restored.</span>
    </div>
  );
}
